export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/bb706895c7b88ed4015ccf8eb7e80ea0.jpg"
          alt="Comfortable home interior"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif text-white mb-6 leading-tight">
          Comfort You Can Trust
          <br />
          <span className="italic font-light">Year-Round Climate Control</span>
        </h1>
        <p className="text-lg md:text-xl text-gray-200 mb-10 max-w-3xl mx-auto">
          Professional heating and cooling services for Kansas City homes and businesses
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-5">
          <button
            onClick={() => scrollToSection('contact')}
            className="bg-black text-white px-8 py-4 rounded-full text-base font-medium hover:bg-gray-800 transition-all whitespace-nowrap"
          >
            Schedule Service
          </button>
          <a
            href="tel:8165551234"
            className="border-2 border-white text-white px-8 py-4 rounded-full text-base font-medium hover:bg-white hover:text-black transition-all whitespace-nowrap"
          >
            Call (816) 555-1234
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white"></i>
      </div>
    </section>
  );
}
